import { render, staticRenderFns } from "./PartnerHighlightCard.vue?vue&type=template&id=4f3538ea&scoped=true"
import script from "./PartnerHighlightCard.vue?vue&type=script&lang=js"
export * from "./PartnerHighlightCard.vue?vue&type=script&lang=js"
import style0 from "./PartnerHighlightCard.vue?vue&type=style&index=0&id=4f3538ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3538ea",
  null
  
)

export default component.exports